
import * as jspb from 'google-protobuf'
import { RpcMessage, OperationResult } from './libs/messaging/common_pb'

export namespace ProtoBuf {
  
  export enum MessageType {
    REQUEST = 0,
    RESPONSE = 1,
  }

  export enum ErrorCode {
    OK = 0,
    TIMEOUT = -1,
    RESOURCE_UNAVAILABLE = -2,
    PERMISSION_DENIED = -3,
    FEATURE_UNAVAILABLE = -4,
    UNIMPLEMENTED = -5,
    INVALID_ARGUMENT = -6,
    UNKNOWN_ERROR = -900,
  }

  export class ProtoBufService {
    static ServiceType = RpcMessage.ServiceType
    static MessageType = RpcMessage.MessageType
    protected service: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 8 = 0;

    create(type: 0 | 1, id: number, control: number, payload: jspb.Message) {
      const message = new RpcMessage()
      message.setType(type)
      message.setId(id)
      message.setService(this.service)
      message.setControl(control)
      message.setPayload(payload.serializeBinary())
      return message.serializeBinary()
    }

    request(id: number, control: number, payload: jspb.Message) {
      return this.create(RpcMessage.MessageType.REQUEST, id, control, payload);
    }

    response(id: number, control: number, payload: jspb.Message) {
      return this.create(RpcMessage.MessageType.RESPONSE, id, control, payload);
    }

    onRequest({ control, payload }: { control: number, payload: Uint8Array }): { type?: string, data: unknown } | null {
      return null
    }

    onResponse({ control, payload }: { control: number, payload: Uint8Array }): { type?: string, data: unknown } | null {
      const data = OperationResult.deserializeBinary(payload)
      return {
        data: data.toObject()
      }
    }

    onMessage = ({ type, control, payload }: { type: 0 | 1, control: number, payload: Uint8Array }): { type?: string, data: unknown } | null => {
      switch (type) {
        case RpcMessage.MessageType.REQUEST:
          return this.onRequest({ control, payload })
        case RpcMessage.MessageType.RESPONSE:
          return this.onResponse({ control, payload })
        default:
          return null
      }
    }

    static handleMessage(msg: string) {
      const buffer = Buffer.from(msg, 'base64')
      const rpc = RpcMessage.deserializeBinary(buffer)
      return rpc.toObject()
    }
    
    static operationResult(msg: string, errorCode: ErrorCode, revision: number, id: number) {
      const opr = new OperationResult()
      opr.setCode(errorCode)
      opr.setSettingsRevision(revision)
      opr.setReason(msg)
      
      const message = new RpcMessage()
      message.setPayload(opr.serializeBinary())
      // message.setPayload(Buffer.from(opr.serializeBinary()).toString('base64'))
      message.setType(MessageType.RESPONSE)
      message.setId(id)
      // message.setService(service)
      // message.setControl(control)
      return message.serializeBinary()
    }
  }
}

export default ProtoBuf.ProtoBufService;